import React from "react";
import {Box, Button, IconButton, Stack, TextField, Tooltip, Typography} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconX} from "@tabler/icons-react";

export const PleaseWaitMessagesTab = ({node, setNode, onUpdate}) => {

  const onChangeMessage = async (index, value) => {
    const state = {...node}
    if (state.data.please_wait_messages[index] !== value) {
      state.data.please_wait_messages[index] = value;
      setNode(state)
    }
  }
  const onUpdateMessage = async () => {
    await onUpdate(node);
  }

  const removeMessage = async (index) => {
    const state = {...node}
    state.data.please_wait_messages = state.data.please_wait_messages?.filter((msg, ind) => ind !== index);
    await onUpdate(state);
  }

  const addMessage = async () => {
    const state = {...node}
    if (!state?.data?.please_wait_messages?.length || state?.data?.please_wait_messages?.length === 0) {
      state.data.please_wait_messages = []
    }
    state.data.please_wait_messages = [...state.data.please_wait_messages, ""];

    await onUpdate(state);
  }

  const {primary, secondary} = menuItemsInfo.please_wait_messages;

  return (
    <>
      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
        <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
      </Box>
      {
        node?.data?.please_wait_messages?.map((msg, index) => {
          return <Stack direction={"row"} gap={1} sx={{position: "relative"}}>
            <TextField
              value={msg}
              size={"small"}
              placeholder={"Write here message..."}
              sx={{flex: 1}} multiline={true} minRows={3} maxRows={5}
              onChange={e => onChangeMessage(index, e.target.value)}
              onBlur={e => onUpdateMessage(index, e.target.value)}
            />
            <Tooltip title={"Delete Message"}>
              <IconButton
                sx={{
                  border: 0.5, borderColor: "rgba(48,148,213,0.6)",
                  p: 0.5, color: "info.main", borderRadius: "50% !important",
                  position: "absolute", top: 3, right: 3,
                  // transform: "translate(10%, -10%)"
                }}
                onClick={() => removeMessage(index)}
              >
                <IconX size={14} />
              </IconButton>
            </Tooltip>
          </Stack>
        })
      }

      <Button
        variant={"outlined"}
        color={"secondary"}
        onClick={addMessage}
      >
        Add new message
      </Button>
    </>
  )
}